function Disclaimer({ goBack }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg,#000000,#1a1a1a,#ffd600)",
        padding: "30px"
      }}
    >
      <button
        onClick={goBack}
        style={{
          padding: "12px 22px",
          border: "none",
          borderRadius: "10px",
          cursor: "pointer",
          fontWeight: "bold",
          backgroundColor: "#ffd600"
        }}
      >
        ⬅ Back
      </button>

      <div
        style={{
          maxWidth: "1000px",
          margin: "25px auto",
          backgroundColor: "white",
          padding: "40px",
          borderRadius: "25px",
          boxShadow:
            "0 8px 25px rgba(0,0,0,0.35)",
          lineHeight: "1.9"
        }}
      >
        <h1
          style={{
            textAlign: "center",
            fontSize: "45px",
            color: "#000"
          }}
        >
          ⚠️ Disclaimer
        </h1>

        <p
          style={{
            textAlign: "center",
            color: "#555",
            fontSize: "18px"
          }}
        >
          Please read this disclaimer before using
          MNHouseFinder.
        </p>

        <hr />

        <h2>1. Platform Purpose</h2>

        <p>
          MNHouseFinder is an online platform
          designed to connect:
        </p>

        <ul>
          <li>🏠 Tenants with landlords.</li>

          <li>
            🏢 Businesses with owners of
            commercial spaces.
          </li>

          <li>
            🏬 Property owners with potential
            clients.
          </li>
        </ul>

        <p>
          We only provide a marketplace for
          users to interact.
        </p>

        <h2>2. Property Information</h2>

        <p>
          Property details displayed on the
          platform are submitted by property
          owners or their representatives.
        </p>

        <p>
          MNHouseFinder cannot guarantee:
        </p>

        <ul>
          <li>Property ownership.</li>

          <li>Property availability.</li>

          <li>Property condition.</li>

          <li>Pricing accuracy.</li>

          <li>Property legality.</li>
        </ul>

        <h2>3. Verify Before Paying</h2>

        <p>
          Users are strongly advised to:
        </p>

        <ul>
          <li>
            ✔ Visit the property physically.
          </li>

          <li>
            ✔ Verify ownership documents.
          </li>

          <li>
            ✔ Confirm availability.
          </li>

          <li>
            ✔ Meet the landlord or owner.
          </li>

          <li>
            ✔ Avoid rushing into payments.
          </li>
        </ul>

        <h2>4. Fraud Warning</h2>

        <p>
          Never send deposits, booking fees or
          rent money to unknown persons without
          proper verification.
        </p>

        <p>
          MNHouseFinder is not responsible for
          losses resulting from fraudulent
          transactions between users.
        </p>

        <h2>5. External Communication</h2>

        <p>
          Once users exchange phone numbers,
          emails or communicate outside the
          application, MNHouseFinder is no
          longer responsible for those private
          interactions.
        </p>

        <h2>6. Service Availability</h2>

        <p>
          Although we strive to keep the system
          available at all times, temporary
          interruptions may occur due to:
        </p>

        <ul>
          <li>System maintenance.</li>

          <li>Internet outages.</li>

          <li>Technical failures.</li>

          <li>Security improvements.</li>
        </ul>

        <h2>7. User Responsibility</h2>

        <p>
          Every user is responsible for the
          information they provide on the
          platform.
        </p>

        <p>
          Users are expected to act honestly,
          respectfully and lawfully.
        </p>

        <h2>8. Limitation of Liability</h2>

        <p>
          MNHouseFinder shall not be liable
          for:
        </p>

        <ul>
          <li>Property disputes.</li>

          <li>Financial losses.</li>

          <li>Rental disagreements.</li>

          <li>Business disagreements.</li>

          <li>Damages caused by third parties.</li>

          <li>Incorrect information posted by users.</li>
        </ul>

        <h2>9. Updates</h2>

        <p>
          This disclaimer may be updated from
          time to time to improve security,
          transparency and user protection.
        </p>

        <h2>10. Contact Information</h2>

        <p>📞 0745 746 190</p>

        <p>📞 0798 061 862</p>

        <p>📧 supportmnhousefinder@gmail.com</p>

        <hr />

        <p
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "18px"
          }}
        >
          © {new Date().getFullYear()} MNHouseFinder.
          All Rights Reserved.
        </p>
      </div>
    </div>
  );
}

export default Disclaimer;